/* Components */
import Check from "./components/checker/Check.vue";
import CheckList from "./components/checklists/CheckList.vue";
import CheckLists from "./components/checklists/CheckLists.vue";
import Checker from "./components/checker/Checker.vue";
import Codes from "./components/Codes.vue";
import Contacts from "./components/Contacts.vue";
import Entries from "./components/checklists/Entries.vue";
import Entry from "./components/checklists/Entry.vue";
import Home from "./components/Home.vue";
import LogIn from "./components/LogIn.vue";
import NotFound from "./components/NotFound.vue";
import RevisionForm from "./components/templates/revisions/Form.vue";
import Revisions from "./components/templates/Revisions.vue";
import Temperature from "./components/Temperature.vue";
import Templates from "./components/templates/Templates.vue";
import Users from "./components/Users.vue";

import store from "./components/store";

async function guard(to, from, next) {
  try {
    await store.dispatch("auth/checkUserSession");
    const entryUrl = from.query.redirectTo;
    if (entryUrl) {
      delete from.query.redirectTo;
      return next(entryUrl); // go to stored url
    } else if (
      to.matched.some((record) => record.meta.requiresAdmin) &&
      !store.getters["auth/isAdmin"]
    ) {
      return next({ path: "/" });
    } else {
      return next(); // all is fine
    }
  } catch (ignore) {
    /* ignore, expected check */
  }

  return next({ path: "/login", query: { redirectTo: to.path } });
}

export default [
  {
    path: "/",
    name: "home",
    component: Home,
  },
  {
    path: "/contacts",
    name: "contacts",
    component: Contacts,
  },
  {
    path: "/temperature",
    name: "temperature",
    component: Temperature,
  },
  {
    path: "/codes",
    name: "codes",
    component: Codes,
  },
  {
    path: "/login",
    name: "login",
    component: LogIn,
  },
  {
    path: "/users",
    name: "users",
    component: Users,
    beforeEnter: guard,
    meta: { requiresAdmin: true },
  },
  {
    path: "/checks",
    name: "checks",
    component: Checker,
    beforeEnter: guard,
  },
  {
    path: "/checks/:timestamp",
    name: "check",
    component: Check,
    beforeEnter: guard,
  },
  {
    path: "/templates",
    name: "templates",
    beforeEnter: guard,
    component: Templates,
  },
  {
    path: "/templates/revision",
    name: "template-create-form",
    beforeEnter: guard,
    component: RevisionForm,
    meta: {
      requiresAdmin: true,
    },
  },
  {
    path: "/templates/:templateId",
    name: "template-revisions",
    beforeEnter: guard,
    component: Revisions,
  },
  {
    path: "/templates/:templateId/revision",
    name: "template-create-revision-form",
    beforeEnter: guard,
    component: RevisionForm,
    meta: {
      requiresAdmin: true,
    },
  },
  {
    path: "/checklists",
    name: "checklists",
    component: CheckLists,
    beforeEnter: guard,
  },
  {
    path: "/checklists/:templateId/entries",
    name: "checklists-entries",
    component: Entries,
    beforeEnter: guard,
  },
  {
    path: "/checklists/:templateId/:rev/entry",
    name: "checklists-entry-form",
    component: CheckList,
    beforeEnter: guard,
  },
  {
    path: "/checklists/:templateId/:rev/entries",
    component: Entries,
    beforeEnter: guard,
  },
  {
    path: "/checklists/:templateId/:rev/entries/:entryId",
    component: Entry,
    beforeEnter: guard,
  },
  {
    path: "*",
    component: NotFound,
  },
];
